import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Heart, Briefcase, Sparkles } from "lucide-react";
import { 
  getDailyHoroscope, 
  getWeeklyHoroscope, 
  getMonthlyHoroscope,
  getFormattedDate,
  getWeekRange,
  getCurrentMonth
} from "@/data/horoscopeContent";

interface HoroscopeContentProps {
  sign: string;
  signName: string;
}

const HoroscopeContent = ({ sign, signName }: HoroscopeContentProps) => {
  const daily = getDailyHoroscope(sign);
  const weekly = getWeeklyHoroscope(sign);
  const monthly = getMonthlyHoroscope(sign);

  return (
    <Card className="p-8 gradient-celestial">
      <Tabs defaultValue="hoy" className="w-full">
        <TabsList className="grid w-full grid-cols-3 mb-8">
          <TabsTrigger value="hoy">Hoy</TabsTrigger>
          <TabsTrigger value="semanal">Semanal</TabsTrigger>
          <TabsTrigger value="mensual">Mensual</TabsTrigger>
        </TabsList>
        
        <TabsContent value="hoy" className="space-y-6">
          <div>
            <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
              <Heart className="w-6 h-6 text-primary" aria-hidden="true" />
              Horóscopo de Hoy para {signName}
            </h3>
            <p className="text-center text-sm text-muted-foreground mb-6">
              {getFormattedDate()} | Número: {daily.numero} | Color: {daily.color}
            </p>
            <div className="space-y-4">
              <div>
                <h4 className="text-base font-semibold mb-2 text-primary">💖 Amor</h4>
                <p className="text-muted-foreground leading-relaxed">{daily.amor}</p>
              </div>
              <div>
                <h4 className="text-base font-semibold mb-2 text-secondary">💼 Trabajo</h4>
                <p className="text-muted-foreground leading-relaxed">{daily.trabajo}</p>
              </div>
              <div>
                <h4 className="text-base font-semibold mb-2 text-accent">✨ Salud</h4>
                <p className="text-muted-foreground leading-relaxed">{daily.salud}</p>
              </div>
              <div>
                <h4 className="text-base font-semibold mb-2 text-accent">💰 Dinero</h4>
                <p className="text-muted-foreground leading-relaxed">{daily.dinero}</p>
              </div>
            </div>
          </div>
        </TabsContent>
        
        <TabsContent value="semanal" className="space-y-6">
          <div>
            <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
              <Briefcase className="w-6 h-6 text-secondary" />
              Horóscopo Semanal: {getWeekRange()}
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              {weekly.general}
            </p>
            <p className="text-muted-foreground leading-relaxed">
              {weekly.enfoque}
            </p>
          </div>
        </TabsContent>
        
        <TabsContent value="mensual" className="space-y-6">
          <div>
            <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
              <Sparkles className="w-6 h-6 text-accent" />
              Horóscopo de {getCurrentMonth()} para {signName}
            </h3>
            <p className="text-muted-foreground leading-relaxed mb-4">
              {monthly.primera_mitad}
            </p>
            <p className="text-muted-foreground leading-relaxed">
              {monthly.segunda_mitad}
            </p>
          </div>
        </TabsContent>
      </Tabs>
    </Card>
  );
};

export default HoroscopeContent;
